import * as fetcher from "../helpers/fetcher";

export async function checkPromocode(promocode, access_token) {
  try {
    return await fetcher.get(`/promo-codes/validate/${promocode}`, {
      Authorization: `Bearer ${access_token}`,
    });
  } catch (error) {
    console.log(error);
    return error;
  }
}

export async function getPromocodes(access_token) {
  try {
    return await fetcher.get(`/promo-codes/me`, {
      Authorization: `Bearer ${access_token}`,
    });
  } catch (error) {
    console.log(error);
    return error;
  }
}
